import { render, staticRenderFns } from "./VerifiedBeltDisplay.vue?vue&type=template&id=1af48f71&scoped=true"
import script from "./VerifiedBeltDisplay.vue?vue&type=script&lang=js"
export * from "./VerifiedBeltDisplay.vue?vue&type=script&lang=js"
import style0 from "./VerifiedBeltDisplay.vue?vue&type=style&index=0&id=1af48f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af48f71",
  null
  
)

export default component.exports